<template>
  <div class="introduce">
    <!-- 页面头部 -->
    <section class="page-header">
      <div class="container">
        <h1>产品介绍</h1>
        <p>全面了解掌柜助手的强大功能</p>
      </div>
    </section>

    <!-- 掌柜跟单介绍 -->
    <section class="product-intro section">
      <div class="container">
        <div class="intro-hero">
          <h2 class="product-title">掌柜跟单</h2>
          <p class="product-subtitle">多线路智能抓单：稳定快速，高效飞单<br>零成本极速上手：技术在线，远程协助<br>开创性跟单模式</p>
          <div class="intro-buttons">
            <router-link to="/download" class="btn btn-primary">立即下载</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="platform-support section">
      <div class="container">
        <h2 class="section-title">多平台游戏支持</h2>
        <div class="feature-content">
          <div class="feature-text">
            <p>支持所有热门平台和游戏，所有操作均可在APP中完成，可以彻底告别电脑，从此摆脱电脑束缚。以往的平台都需要下载打盘助手和环境插件，需要进行挂盘等操作，在掌柜助手中完全不需要多余下载任何程序，所有盘口配置、账号信息以及开关皆可通过后台完成操作，且不需要挂机。</p>
            <p>掌柜助手通过AI分配最佳线路，稳定挂盘不掉线，只要用户下单成功就一定能飞单成功，无需担忧打盘助手状态和电脑状态告别既定设备程序。</p>
            <p>掌柜助手支持任意设定多种配置，支持相同盘口不同账号，且任意分配游戏和打盘比例，支持设定盈亏自动关盘和异常通知。</p>
          </div>
          <div class="feature-highlights">
            <div class="highlight-item">
              <div class="highlight-icon">🎯</div>
              <h4>智能线路选择</h4>
              <p>自动识别导航线路，择优选择最佳线路</p>
            </div>
            <div class="highlight-item">
              <div class="highlight-icon">🔄</div>
              <h4>多账号调配</h4>
              <p>多个账号任意绑定不同配置</p>
            </div>
            <div class="highlight-item">
              <div class="highlight-icon">⚡</div>
              <h4>史诗级调优</h4>
              <p>多线程抓取注单，稳定不掉线</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 多元化设置 -->
    <section class="diverse-settings section">
      <div class="container">
        <h2 class="section-title">多元化设置</h2>
        <div class="settings-grid">
          <div class="setting-card card">
            <div class="setting-icon">👥</div>
            <h3>代理层级显示</h3>
            <p>支持按代理层级显示会员，账号归属一目了然，设置更方便更快捷</p>
          </div>
          <div class="setting-card card">
            <div class="setting-icon">🎲</div>
            <h3>跟反设置</h3>
            <p>支持会员一键跟反</p>
          </div>
          <div class="setting-card card">
            <div class="setting-icon">🎮</div>
            <h3>游戏独立开启</h3>
            <p>支持独立开启需要跟单的游戏，体验更佳，抓单更稳定飞单更快速</p>
          </div>
          <div class="setting-card card">
            <div class="setting-icon">📧</div>
            <h3>邮件告警</h3>
            <p>支持止盈止损邮件告警，让你无需时刻守候，止盈止损任你掌控</p>
          </div>
          <div class="setting-card card">
            <div class="setting-icon">💰</div>
            <h3>大额分投</h3>
            <p>支持大额分投，玩法过滤，飞单安全无忧，你想怎么玩就怎么玩</p>
          </div>
          <div class="setting-card card">
            <div class="setting-icon">🛡️</div>
            <h3>安全保障</h3>
            <p>软件不上传您的任何个人数据，所有数据加密处理，绝对保障您的个人信息</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 稳定安全 -->
    <section class="security section">
      <div class="container">
        <h2 class="section-title">稳定安全，技术在线，实时协助</h2>
        <div class="security-content">
          <div class="security-features">
            <div class="security-item">
              <div class="security-icon">🔒</div>
              <h3>数据安全</h3>
              <p>软件不上传您的任何个人数据，所有数据加密处理，绝对保障您的个人信息不会有丝毫泄露</p>
            </div>
            <div class="security-item">
              <div class="security-icon">🆓</div>
              <h3>免费试用</h3>
              <p>提供完全免费的全功能试用，全程真人在线协助，技术人员随时待命解决您的所有问题</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="robot-products section">
      <div class="container">
        <div class="products-showcase">
          <div class="product-section">
            <h2 class="product-title">掌柜助手</h2>
            <p class="product-subtitle">开群助手，网页后台+手机APP，集最新的开发理念</p>
            <div class="product-buttons">
              <router-link to="/download" class="btn btn-primary">立即下载</router-link>
            </div>
          </div>

          <div class="product-details">
            <div class="detail-item">
              <h3>WEB网页后台</h3>
              <p>全新WEB机器人架构，着重优化使用体验和数据安全。支持20+等所有热门游戏，支持多游戏独立设置，支持群主每日自动返水，所有群主线路均使用在线防御，确保数据安全体验流畅。打盘助手多线路节点获取注单，支持所有热门平台，针对多个热门平台独立优化，体验更好飞单更快更稳定。</p>
            </div>

            <div class="detail-item">
              <h3>APP房主端</h3>
              <p>群主身份登录APP，从此摆脱电脑束缚，走到哪玩到哪。房主APP体验更流畅使用更方便，支持WEB机器人所有功能和设置，群内消息实时查看，极速推送，不错过任何一个帮您赚钱的机会。提供IOS&Android原生APP下载，支持TF签，企业签，超签等多种安全下载途径。</p>
            </div>

            <div class="detail-item">
              <h3>支持测试</h3>
              <p>支持测试，支持远程协助，先测试，再开号。服务时间:早9点到晚上12点！欢迎合作！</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部产品导航 -->
    <section class="bottom-nav section">
      <div class="container">
        <div class="nav-grid">
          <div class="nav-item card">
            <h3>掌柜跟单</h3>
            <p>多线路智能抓单，零成本极速上手</p>
            <div class="nav-buttons">
              <router-link to="/download" class="btn">立即下载</router-link>
            </div>
          </div>
          <div class="nav-item card">
            <h3>掌柜助手</h3>
            <p>开群机器人，网页后台+手机APP，集最新的开发理念</p>
            <div class="nav-buttons">
              <router-link to="/download" class="btn">立即下载</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Introduce',
  mounted() {
    this.animateOnScroll()
  },
  methods: {
    animateOnScroll() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in')
          }
        })
      })

      const elements = document.querySelectorAll('.card, .highlight-item, .security-item, .detail-item')
      elements.forEach(el => observer.observe(el))
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 80px 0 60px;
  text-align: center;
}

.page-header h1 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 18px;
  opacity: 0.9;
}

.product-intro {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.intro-hero {
  text-align: center;
  padding: 40px 0;
}

.product-title {
  font-size: 36px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.product-subtitle {
  font-size: 18px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 30px;
}

.intro-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.feature-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
  align-items: start;
}

.feature-text p {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin-bottom: 20px;
}

.feature-highlights {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.highlight-item {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateX(30px);
}

.highlight-item.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.highlight-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.highlight-icon {
  font-size: 24px;
  margin-bottom: 10px;
}

.highlight-item h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.highlight-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.setting-card {
  text-align: center;
  padding: 30px 20px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.setting-card.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.setting-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.setting-card h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
}

.setting-card p {
  color: #666;
  line-height: 1.6;
}

.security {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
}

.security .section-title {
  color: white;
  margin-bottom: 40px;
}

.security-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 40px;
}

.security-item {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease;
}

.security-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.security-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.security-item h3 {
  font-size: 24px;
  margin-bottom: 15px;
  color: #3498db;
}

.security-item p {
  line-height: 1.6;
  opacity: 0.9;
}

.robot-products {
  background: white;
}

.products-showcase {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.product-section {
  margin-bottom: 50px;
}

.product-details {
  text-align: left;
}

.detail-item {
  margin-bottom: 40px;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 10px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
}

.detail-item.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.detail-item h3 {
  font-size: 22px;
  color: #333;
  margin-bottom: 15px;
}

.detail-item p {
  color: #666;
  line-height: 1.8;
}

.bottom-nav {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
}

.nav-item {
  text-align: center;
  padding: 40px 30px;
}

.nav-item h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
}

.nav-item p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.nav-buttons, .product-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    padding: 60px 0 40px;
  }
  
  .page-header h1 {
    font-size: 32px;
  }
  
  .product-title {
    font-size: 28px;
  }
  
  .feature-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .settings-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .security-features {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .nav-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .intro-buttons, .nav-buttons, .product-buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>
